<template>
	<div class="speaker-notes" v-if="showNotes()">
		<select v-model="currentPage" @change="jumpToPage">
			<option v-for="page in pages()" :key="page.path" :value="page.path">{{page.component}}</option>
		</select>
		<ul>
			<li v-for="(item,i) in notes" :key="i">{{item}}</li>
		</ul>
	</div>

</template>

<script>
	import {mapGetters} from "vuex";

	export default {
		name: 'speaker-notes',
		props: {
			notes: {
				type: Array,
				required: true,
			}
		},
		data() {
			return {
				currentPage: "",
			};
		},
		methods: {
			...mapGetters(['showNotes', 'pages']),
			jumpToPage() {
				this.$router.push(this.currentPage);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.speaker-notes {
		text-align: left;
		background-color: $speaker-notes-background;
	}
</style>
